import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeComponent from '../components/HomeComponent';
import PrivacyAndRefundComponent from '../components/PrivacyAndRefundComponent';
import TermsAndConditionsComponent from '../components/TermsandConditionsComponent';
import OurStoryPageComponent from '../components/OurStoryPageComponent';
import BlogsPageComponent from '../components/BlogsPageComponent';
import IndividualBlogsComponent from '../components/IndividualBlogsComponent';
import BookYOurAurmSafe from '../components/BookYourAurmSafe';
import FaqsComponent from '../components/FaqsComponent';

function AppRouter() {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<HomeComponent />} />
      <Route
        path="/privacy-policy"
        element={<PrivacyAndRefundComponent flag={true} />}
      />
      <Route
        path="/refund-policy"
        element={<PrivacyAndRefundComponent flag={false} />}
      />
      <Route path='/terms-and-conditions' element={<TermsAndConditionsComponent />} />
      <Route path='/our_story' element={<OurStoryPageComponent />} />
      <Route path='/blogs' element={<BlogsPageComponent />} />
      <Route path='/individual_blogs/:blogId' element={<IndividualBlogsComponent />} />
      <Route path='/apps' element={<BookYOurAurmSafe/>} />
      <Route path='/faq' element={<FaqsComponent/>} />
    </Routes>
  </Router>
  );
}

export default AppRouter;